$(document).ready(function () {

  let stickyAdded = false;
  window.addEventListener('scroll', function () {
    const header = document.querySelector('#header');
    const isStickyHeader = header.getAttribute("data-sticky");

    if (window.scrollY > 150 && !stickyAdded && isStickyHeader == "true") {
      header.classList.add('mobile_nav-fixed--true');
      stickyAdded = true;
    } else if (window.scrollY <= 150 && stickyAdded) {
      header.classList.remove('mobile_nav-fixed--true');
      stickyAdded = false;
    }
  });
  
  $('.moreless-button').click(function () {
    $('.moretext').slideToggle();
    if ($('.moreless-button').text() == 'Read more') {
      $(this).text();
    } else {
      $(this).text('');
    };
  });

  $('.product_list_item').not('.slick-initialized').slick({
    infinite: true,
    centerMode: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://puffignite.co/cdn/shop/files/slider-arrow.png'></button>",
    nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://puffignite.co/cdn/shop/files/slider-arrow.png'></button>",
    responsive: [
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  // Text with collection slider
  $.fn.CollectionSliderRun = function () {
      if ($(window).width() <= 575) {
          $('.main_image_box').not('.slick-initialized').slick({
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>",
              nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>"
          });
      } else {
        $('.main_image_box.slick-initialized').slick('unslick')
      }
  };

  $.fn.CollectionSliderRun();
  $(window).on("resize", function () {
      $.fn.CollectionSliderRun();
  });

  // OFFER AND SHOP 
  $.fn.shopApprel = function () {
      if ($(window).width() <= 575) {
          $('.offer-shop .main_image').not('.slick-initialized').slick({
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>",
              nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://cdn.shopify.com/s/files/1/0072/5119/8050/files/slick-arrow_600x.png?v=1684821606'></button>"
          });
      } else {
        $('.offer-shop .main_image.slick-initialized').slick('unslick')
      }
  };
  $.fn.shopApprel();
  $(window).on("resize", function () {
      $.fn.shopApprel();
  });

  // Gallery Slider Mobile
  $.fn.gallerySlider = function () {
    var $gallerySlider = $('.mobile-slider .masonry');
    if ($(window).width() < 799) {
      if($gallerySlider.hasClass('slick-initialized')) {
        $gallerySlider.slick('unslick');
      }
      $gallerySlider.slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    } else {
      if($gallerySlider.hasClass('slick-initialized')) {
        $gallerySlider.slick('unslick');
      }
    }
  }
  $.fn.gallerySlider();
  $(window).on("resize", function () {
    $.fn.gallerySlider();
  });

  // Select all links with hashes
  $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function(event) {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr('tabindex','-1');
            $target.focus();
          };
        });
      }
    }
  });

});
